export enum FirstDayOfWeekEnum {
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Monday = 'Monday',
}
